'use client';

import { Button } from '@galapagos/design-system/web';
import { useTranslation } from 'react-i18next';
import { useSignupNavigation } from '../../hooks/useSignupNavigation';
import { useStepHeading } from '../../hooks/useStepHeading';
import { wrapUpExitStep } from '../../wrap-up/branching';
import { useWrapUpContext } from '../../wrap-up/useWrapUpContext';
import { gated } from './gated';
import { WrapUpActions, WrapUpFrame } from './WrapUpFrame';

/** `/booking-unavailable/`: no open times; the care team will reach out. */
function BookingUnavailableStep() {
  const { t } = useTranslation('signup');
  const title = t('wrapUp.bookingUnavailable.title');
  const headingRef = useStepHeading(title);
  const { goToStep } = useSignupNavigation();
  const state = useWrapUpContext();
  return (
    <WrapUpFrame
      title={title}
      description={t('wrapUp.bookingUnavailable.description')}
      headingRef={headingRef}
    >
      <WrapUpActions>
        <Button
          size="L"
          type="Primary"
          label={t('wrapUp.bookingUnavailable.continue')}
          actionId="signup.booking-unavailable-continue.activate"
          data-testid="signup-booking-unavailable-continue-button"
          onPress={() => goToStep(wrapUpExitStep(state.ready ? state.context : undefined))}
        />
      </WrapUpActions>
    </WrapUpFrame>
  );
}

export const BookingUnavailableScreen = gated(BookingUnavailableStep, 'booking-unavailable');
